// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Address.module.css */

.AddressInfo_container__soNht {
  border-radius: 5px;
  width: 100%;
}

.AddressInfo_container__soNht h2 {
  text-align: left;
  margin-bottom: 20px;
}

.AddressInfo_container__soNht h2::after {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background-color: #ccc;
  margin: 10px 0;
}

.AddressInfo_loginButton__S9RTh {
  background-color: #d9534f;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  cursor: pointer;
}

.AddressInfo_loginButton__S9RTh:hover {
  background-color: #c9302c;
}

.AddressInfo_row__slGss {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 15px;
  flex-wrap: wrap; /* Permite elementelor să treacă pe următoarea linie dacă spațiul este insuficient */
}

.AddressInfo_field__0y8br {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.AddressInfo_checkboxField__iAI4m {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.AddressInfo_input__b7b6f {
  padding: 9px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.AddressInfo_input__b7b6f:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.AddressInfo_input__b7b6f.AddressInfo_error__wBe38 {
  border-color: #ff5f5f;
  background-color: #ffe6e6;
  box-shadow: 0 0 5px rgba(255, 95, 95, 0.5);
}

.AddressInfo_label__behT6 {
  margin-bottom: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ShoppingChart/Address/AddressInfo/AddressInfo.module.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe,EAAE,oFAAoF;AACvG;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/* Address.module.css */\n\n.container {\n  border-radius: 5px;\n  width: 100%;\n}\n\n.container h2 {\n  text-align: left;\n  margin-bottom: 20px;\n}\n\n.container h2::after {\n  content: \"\";\n  display: block;\n  width: 100%;\n  height: 1px;\n  background-color: #ccc;\n  margin: 10px 0;\n}\n\n.loginButton {\n  background-color: #d9534f;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  padding: 5px 10px;\n  cursor: pointer;\n}\n\n.loginButton:hover {\n  background-color: #c9302c;\n}\n\n.row {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 15px;\n  flex-wrap: wrap; /* Permite elementelor să treacă pe următoarea linie dacă spațiul este insuficient */\n}\n\n.field {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.checkboxField {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.input {\n  padding: 9px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.input:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n}\n\n.input.error {\n  border-color: #ff5f5f;\n  background-color: #ffe6e6;\n  box-shadow: 0 0 5px rgba(255, 95, 95, 0.5);\n}\n\n.label {\n  margin-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddressInfo_container__soNht`,
	"loginButton": `AddressInfo_loginButton__S9RTh`,
	"row": `AddressInfo_row__slGss`,
	"field": `AddressInfo_field__0y8br`,
	"checkboxField": `AddressInfo_checkboxField__iAI4m`,
	"input": `AddressInfo_input__b7b6f`,
	"error": `AddressInfo_error__wBe38`,
	"label": `AddressInfo_label__behT6`
};
export default ___CSS_LOADER_EXPORT___;
